import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { catalogApi, type Catalog, type CatalogDashboard } from '../../api/catalog';

export function ClassificationDashboardPage() {
  const [dashboard, setDashboard] = useState<CatalogDashboard | null>(null);
  const [catalogs, setCatalogs] = useState<Catalog[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void catalogApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
    void catalogApi.listCatalogs().then(setCatalogs).catch(() => undefined);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/catalog" className="text-sm text-slate-600 hover:underline">← Catalogs</Link>
      <h1 className="mt-4 text-2xl font-semibold">Classification Dashboard</h1>
      <p className="mt-1 text-sm text-slate-600">Overview of product classification coverage and AI suggestions.</p>
      <div className="mt-4 flex gap-3 text-sm">
        <Link to="/catalog/classification/review" className="text-slate-700 hover:underline">AI review queue</Link>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Object.entries(dashboard?.stats ?? {}).map(([key, value]) => (
          <div key={key} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{key.replace(/_/g, ' ')}</p>
            <p className="mt-1 text-2xl font-semibold">{String(value)}</p>
          </div>
        ))}
      </div>
      <div className="mt-8 rounded-xl border bg-white p-6">
        <h2 className="font-semibold">Catalogs</h2>
        <ul className="mt-3 space-y-2 text-sm">
          {catalogs.map((c) => (
            <li key={c.id} className="flex justify-between border-b py-2 last:border-0">
              <span>{c.name}</span>
              <span className="text-slate-500">{c.status}</span>
            </li>
          ))}
          {!catalogs.length && <li className="text-slate-500">No catalogs configured.</li>}
        </ul>
      </div>
    </div>
  );
}
